<template>
  <div class="container">
    <div class="top-search">
      <div class="search">
        <i class="icon icon-search"></i>
        <input v-model.lazy="search.keyWord" type="" name="" :placeholder="getDict(55)">
      </div>
      <div class="filter" v-if="false">
        <span>{{getDict(56)}}</span>
        <i class="icon icon-filter"></i>
      </div>
    </div>
    <div class="bottom-box">
      <div class="left-banner" v-if="subscriptionList.length || bannerList.length">
        <div class="banner-only" v-if="subscriptionList.length == 0">
          <imgPlayer 
            @clickImg="clickBanner" 
            class="img-box" 
            :imgList="bannerList.map((obj)=>{return obj.img})" 
            ref="bannerPlayer" 
            v-model="bannerIndex"
            :autoMove="5"
          ></imgPlayer>
          <div class="img-select">
            <div class="btn" :class="{active:bannerIndex == index-1}" v-for="index in bannerList.length"></div>
          </div>
        </div>
        <template v-if="subscriptionList.length">
          <div class="one-subscription" v-if="subscriptionList.length + bannerList.length == 1">
            <div class="img">
              <img src="./imgs/pic1.png">
            </div>
            <div class="subscription-info">
              <div class="name">{{subscriptionList[0].name}}</div>
              <div class="order">
                <span class="time">
                  <i class="icon icon-clock"></i>
                  <span>{{subscriptionList[0].time}}</span>
                </span>
                <span class="num">
                  <i class="icon icon-watch-people-yellow-2"></i>
                  <span>{{subscriptionList[0].orderNum | readableNum }}</span>
                </span>
                <span class="btn" :class="subscriptionList[0].ifOrder?'ordered':''">{{subscriptionList[0].ifOrder?getDict(57):getDict(58)}}</span>
              </div>
            </div>
          </div>
          <div class="more-subscription" v-if="subscriptionList.length + bannerList.length > 1">
            <div class="banner" v-if="bannerList.length">
              <imgPlayer 
                @clickImg="clickBanner" 
                class="img-box" 
                :imgList="bannerList.map((obj)=>{return obj.img})" 
                ref="bannerPlayer" 
                v-model="bannerIndex"
                :autoMove="5"
              ></imgPlayer>
              <div class="img-select">
                <div class="btn" :class="{active:bannerIndex == index-1}" v-for="index in bannerList.length"></div>
              </div>
            </div>
            <div class="subscription">
              <div class="order-item-block" v-for="(node,index) in subscriptionList">
                <div class="img">
                  <img src="./imgs/pic1.png">
                </div>
                <div class="subscription-info">
                  <div class="name">{{node.name}}</div>
                  <div class="order">
                    <span class="time">
                      <i class="icon icon-clock"></i>
                      <span>{{node.time}}</span>
                    </span>
                    <span class="num">
                      <i class="icon icon-watch-people-yellow-2"></i>
                      <span>{{node.orderNum | readableNum }}</span>
                    </span>
                    <span class="btn" :class="node.ifOrder?'ordered':''">{{node.ifOrder?getDict(57):getDict(58)}}</span>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            
          </div>
        </template>
      </div>
      <div class="right-news">
        <div class="news-block" v-for="(news,index) in filterNewsList" :key="index">
          <div class="title">
            <span class="label">{{getDict(59)}}</span>
            <span>{{news.title}}</span>
          </div>
          <NewsDesc class="desc" :text="news.comment"></NewsDesc>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'
  import NewsDesc from './newsDesc'
  import ImgPlayer from '../../components/imgPlayer'

  export default {
    name: 'news',
    mixins:[getPageLevelMixin],
    props:{
      isRouteOpen:{
        default:false,
      },
    },
    data(){
      return {
        bannerIndex:0,
        bannerObjList:[
          // {
          //   "name":"广告1",
          //   "img":"/upload/banner/linweikai-1558007918087-火箭瞭望台.png",
          //   "videoId":""
          // },
          // {
          //   "name":"广告1",
          //   "img":"/upload/banner/linweikai-1558007918087-火箭瞭望台.png",
          //   "videoId":""
          // },
          // {
          //   "name":"广告1",
          //   "img":"/upload/banner/linweikai-1558007918087-火箭瞭望台.png",
          //   "videoId":""
          // },
          // {
          //   "name":"广告1",
          //   "img":"/upload/banner/linweikai-1558007918087-火箭瞭望台.png",
          //   "videoId":""
          // },
          // {
          //   "name":"ad",
          //   "img":"/upload/banner/wb.chenjingwen-1554708450801-20180727105738_31450.jpg",
          //   "videoId":""
          // },
          // {
          //   "name":"test",
          //   "img":"/upload/banner/linweikai-1554714623048-IMG20190408_153115.png"
          // }
        ],
        subscriptionList:[/*{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:false,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:false,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:false,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:false,
        },*/],
        pageLevel:1,
        search:{
          keyWord:'',
        },
        //https://sixhorse.game.163.com/news/outer/newslist.do?contentkind=30665&limit=15&start=1
        newsList:[/*
          {
            id: "3388024c-d4d1-4fa5-8571-1e5ad2a0251d",
            code: "810025",
            title: "戦場に轟く「超必殺忍蜂！」。3月15日にスタートする「荒野行動」×「KOF '98UM」コラボの詳細や見どころを紹介",
            url: "//www.knivesout.jp/news/official/20190422/30665_810025.html",
            showtime: 1553079180000,
            author: "",
            imageFileId: "95a6891b-d628-4ea0-9259-a1f03ab141d6",
            imageUrl: "https://nie.res.netease.com/r/pic/20190422/95a6891b-d628-4ea0-9259-a1f03ab141d6.png",
            imageUrls: "https://nie.res.netease.com/r/pic/20190422/c9c397f6-2a90-4027-9a42-e72a5c6702f3.png;https://nie.res.netease.com/r/pic/20190422/ad4d3ffb-f3a9-4dc4-934d-06dc21875848.png;",
            redirectUrl: "",
            comment: "NetEaseGamesがサービス中のバトルロイヤルゲーム「荒野行動-KnivesOut-」(以下，荒野行動。iOS/Android/PC)で，SNKの対戦格闘ゲーム「THEKINGOFFIGHTERS'98ULTIMATEMATCH」(以下，KOF'98UM)とのコラボレーションイベントが，2019年3月15日0：00から3月28日23：59まで開催される。",
            type: 1,
            ckName: "ニュース",
            shortTitle: "",
            subTitle: "",
            resourceUrls: null,
            showMore:false,
          }
        */]
      }
    },
    computed:{
      ...mapState(['_feedbackObj','lang']),
      bannerList(){
        // return [];
        if(this.bannerObjList){
          return this.bannerObjList.map((banner)=>{
            return {
              img: `/upload/banner/${banner.image.size5x7}`,
              videoId:banner.videoId,
              jump:banner.jump,
            }
          });
        }else{
          return [];
        }
      },
      filterNewsList(){
        if(this.search.keyWord){
          return this.newsList.filter((node)=>{
            return node.title.indexOf(this.search.keyWord) != -1 || node.comment.indexOf(this.search.keyWord) != -1
          });
        }else{
          return this.newsList;
        }
      }
      
    },
    watch:{
    },
    methods: {
      getDict,
      async getNews(){
        let result = await axios.get(`/api/newsList`);
        if(result.status == 200){
          if(result.data){
            let data = result.data;
            if(data.list){
              this.newsList = data.list.map((node)=>{
                node.showMore = false;
                return node;
              });
              if(data.bannerList && data.bannerList[0]){
                this.bannerObjList = data.bannerList[0].banners
              }
              
            }
            
          }
        }
      },
      clickBanner(index){
        console.log(index);
        if(this.bannerList[index]){
          if(this.bannerList[index].jump){
            let url = this.bannerList[index].jump;
            url = /^https?:\/\//.test(url)? url:'http://'+url
            location.href = url
          }else if(this.bannerList[index].videoId){
            this.goVideo(this.bannerList[index].videoId);
          }
        }
      },
      goVideo(id){
        this.$router.push(`/video/${id}`);
      },
    },
    components: {
      alert,NewsDesc,ImgPlayer
    },
    mounted(){
      
    },
    created(){
      this.getNews()
    }
  }
</script>

<style lang="scss" scoped>
  .container{
    margin: .2rem;
    // display: flex;
    // flex: 1;


    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .top-search{
      $searchHeight:0.44rem;
      $font-size: 0.23rem;
      display: flex;
      .search{
        flex: 1;
        display: flex;
        align-items: center;
        width: 4rem;
        height: $searchHeight;
        background-color: rgba(255,255,255,0.7);
        padding: 0 0.2rem;
        position: relative;

        
        .icon{
          height:  $font-size;
          width:  $font-size *0.9;
        }
        input{
          flex: 1;
          height: 0.35rem;
          padding: 0;
          border: 0;
          font-size:  $font-size;
          // color: #fff;
          color: #232324;
          background:none;
        }
        .hover{
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }

        &.active{
          flex-grow: 1;
        }
      }
      .filter{
        font-size: $font-size;
        display: flex;
        align-items: center;
        margin-left: 0.5rem;
        margin-right: 0.3rem;
        .icon{
          margin-left: 0.1rem;
          margin-top: $font-size * 0.3
        }
      }
    }

    .bottom-box{
      $height: 5rem;
      height: $height;
      display: flex;
      margin-top: 0.2rem;

      .left-banner{
        $width: $height * 3/5;
        // $width: 2.8rem;
        height: 100%;
        width:$width;
        margin-right: .3rem;
        // background-color: rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .banner-only{
          width: 100%;
          height: 100%;
          position: relative;
          .img-box{
            width:$width;
            height: $width * 5/3;
            overflow: hidden;
            display: flex;
            img{
              width: 100%;
              height: 100%;
            }
          }

          .img-select{
            width: 100%;
            position: absolute;
            $point-height: 0.18rem ;
            height: $point-height;
            bottom: $point-height;
            z-index: 5;
            // background-color: rgba(0,0,0,0.1);
            display: flex;
            justify-content:center;
            .btn{
              height: 100%;
              width: $point-height * 1.8;
              border-radius: $point-height;
              background-color: rgba(255,255,255,0.5);
              margin: 0 $point-height/2;

              &.active{
                background-color: rgba(237,174,7,1);
              }
            }
          }
        }

        .subscription-info{
          width: 100%;
          height: $height - $width * 7/5;
          background-color: #fff;
          
          padding: 0.05rem 0.15rem;
          display: flex;
              flex-direction: column;
              justify-content: space-around;

          .name{
            font-weight: 600;
            font-size: 0.2rem;
          }
          .order{
            display: flex;
            align-items: center;
            $font-size: 0.17rem;
            font-size: $font-size;
            .icon{
              $size:$font-size *1.2;
              height: $size;
              width: $size;
              vertical-align: bottom;
              margin-right: 0.01rem;

              &.icon-watch-people-yellow-2{
                width: $size *21/19
              }
            }

            .time{}
            .num{
              margin-left: 0.15rem;
              color: #dca029;
              flex: 1;
            }

            .btn{
              display: inline-block;
              height: $font-size*1.7;
              line-height: $font-size*1.7;
              text-align: center;
              width: 0.7rem;
              background-color: #ffc952;
              border-radius: 0.05rem;

              &.ordered{
                background-color: #c8c8cb;
              }

            }
          }
        }
        .one-subscription{
          .img{
            width: $width;
            height: $width * 7/5;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .subscription-info{
            
            .name{
            }
            .order{
              .icon{

                &.icon-watch-people-yellow-2{
                }
              }

              .time{}
              .num{
              }

              .btn{

                &.ordered{
                }

              }
            }
          }
          
        }
        .more-subscription{
          display: flex;
          flex-direction: column;
          height: 100%;
          .banner{
            width:$width;
            height: $width * 3/5;
            
            position: relative;
            margin-bottom: 0.1rem;
            .img-box{
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: flex;
              img{
                width: 100%;
                height: 100%;
              }
            }

            .img-select{
              width: 100%;
              position: absolute;
              $point-height: 0.18rem ;
              height: $point-height;
              bottom: $point-height;
              z-index: 5;
              // background-color: rgba(0,0,0,0.1);
              display: flex;
              justify-content:center;
              .btn{
                height: 100%;
                width: $point-height * 1.8;
                border-radius: $point-height;
                background-color: rgba(255,255,255,0.5);
                margin: 0 $point-height/2;

                &.active{
                  background-color: rgba(237,174,7,1);
                }
              }
            }
          }
          .subscription{
            overflow: scroll;
            flex-grow: 1;
            flex-shrink: 1;
            .order-item-block{
              &:not(:first-child){
                margin-top: 0.02rem;
              }
              // display: flex;
              $img-width:$width * 0.3;
              .img{
                vertical-align: bottom;
                display: inline-flex;
                width: $img-width;
                height: $img-width * 7/5;
                flex-shrink: 0;
                img{
                  width: 100%;
                  height: 100%;
                }
              }

              .subscription-info{
                vertical-align: bottom;
                width: $width - $img-width;
                display: inline-block;
                height: $img-width * 7/5;;
                .name{
                  font-size: 0.18rem;
                }
                .order{
                  flex-direction: column;
                  align-items: end;
                  .icon{
                    &.icon-watch-people-yellow-2{
                    }
                  }

                  .time{}
                  .num{
                    margin:0.05rem 0;
                  }

                  .btn{
                    width: 100%;
                    &.ordered{
                    }

                  }
                }
              }
            }
          }
          


        }
        

        

        
      }
      .right-news{
        flex: 1;
        background-color: #3d3d3d;
        height: 100%;
        overflow: scroll;

        .news-block{

          &:nth-child(odd) {
            background-color: #3d3d3d;
          }
          &:nth-child(even) {
            background-color: #4a4a4a;
          }

          padding: 0.2rem;
          .title{
            font-size: 0.23rem;
            color: #fff;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            .label{
              color: #ffc44f;
            }
          }
          .desc{
            font-size: 0.18rem;
            color: #fff;



          }
        }
      }
    }

   
  }

</style>
